<template>
  <div class="json-row">
    <OLoadingDialog v-model="isLoading" />

    <div class="col-6 pa-6 scroll-y">
      <pre>{{ trip | prettyJson('(vazio)') }}</pre>
    </div>
    <div class="col-6 v-row" style="border-left: 1px solid #ccc">
      <div class="pa-6" style="width: 300px">
        <OHoldToConfirm
          style="height: 75px"
          :color="btnColor"
          block
          @confirmed="forceClose(true)"
          label="Fechar (válido)"
        />
      </div>
      <div class="pa-6" style="width: 300px">
        <OHoldToConfirm
          style="height: 75px"
          :color="btnColor"
          block
          @confirmed="forceClose(false)"
          label="Fechar (inválido)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { OrgApi } from '@/models'

export default {
  components: {
    OHoldToConfirm: require('oderon-vue/cpts/OHoldToConfirm').default
  },
  props: {
    value: {}
  },
  data() {
    return { isLoading: false }
  },
  computed: {
    trip() {
      return this.value ? this.value.mainTrip : {}
    },
    btnColor() {
      let name = this.value && this.value.org && this.value.org.name
      if (name == null) return 'error'
      if (name.includes('dev/')) return 'success'
      if (name.includes('hlg/')) return 'amber darken-1 white--text'
      return 'error'
    }
  },
  methods: {
    forceClose(isValid) {
      let tripId = this.trip.id
      let fetcher = new OrgApi(this.value.org.name)
      this.$loading(async () => {
        await fetcher.post(`trips/${tripId}/force-close`, { isValid })
        this.$snack('Trecho fechado com sucesso')
        this.$emit('forceClosed', { isValid })
      })
    }
  }
}
</script>

<style lang="sass">
.json-row
  display: flex
  flex-flow: row nowrap
  justify-content: stretch
  max-height: 100%
  overflow: hidden
</style>
